import React, { memo, useEffect, useState } from 'react'
import { Modal, Button } from '@ow/comps'
import Users from './users'

const footer = ({ close, submit, selectedUserListLength, userListLength }) => {
  return (
    <div className="flex flex-1 justify-between items-center">
      <div className="text-sm">
        共查询到 {userListLength} 条数据，已选中 {selectedUserListLength} 条
      </div>
      <div className="flex gap-2">
        <Button stroke onClick={close}>
          取消
        </Button>
        <Button type="primary" onClick={submit}>
          确认
        </Button>
      </div>
    </div>
  )
}

const UserModal = function ({
  trigger,
  open,
  onOpen,
  onClose,
  onConfirm,
  value,
}) {
  const [userListLength, setUserListLength] = useState(0)
  const [selected, setSelected] = useState(value)

  const onUserFilter = (list) => {
    setUserListLength(list.length)
  }

  useEffect(() => {
    setSelected(value)
  }, [value])

  return (
    <Modal
      trigger={trigger}
      open={open}
      showCloseButton
      width="1200px"
      title="选择绑定用户"
      closeOnDocumentClick={false}
      onOpen={onOpen}
      onClose={onClose}
      footer={({ close }) =>
        footer({
          close,
          submit: () => {
            onConfirm(selected)
            close()
          },
          selectedUserListLength: selected.length,
          userListLength,
        })
      }
    >
      <div>
        <Users
          value={selected}
          onChange={setSelected}
          onUserFilter={onUserFilter}
        />
      </div>
    </Modal>
  )
}

export default memo(UserModal)
